import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import CreditBuilderModule from 'components/CreditBuilderModule';
import PlusOverviewBannerModule from 'partial/OfferManager/modules/PlusOverviewBannerModule';
import './UnifiedCashEnrollPlusBanner.scss';

const SwitchUnifiedModule = props => {
  const { module, isTwoModules } = props;

  switch (module?.module) {
    case 'CREDIT_BUILDER_MODULE':
      return <CreditBuilderModule {...props} isTwoModules={isTwoModules} />;
    case 'SUBSCRIPTION_OVERVIEW_BANNER_MODULE':
      return (
        <PlusOverviewBannerModule
          {...props}
          plusBannerOverviewWebConfig={module?.plusBannerOverviewWebConfig}
          isTwoModules={isTwoModules}
        />
      );
    default:
      return <></>;
  }
};

const UnifiedCashEnrollPlusBannerController = props => {
  const { unifiedModules } = props;
  const isTwoModules = unifiedModules?.length === 2;

  return (
    <FlexContainer className={'UnifiedCashEnrollPlusBanner width100 gap-20'}>
      {unifiedModules?.map(module => {
        return (
          <SwitchUnifiedModule
            {...props}
            module={module}
            isTwoModules={isTwoModules}
          />
        );
      })}
    </FlexContainer>
  );
};

export default UnifiedCashEnrollPlusBannerController;
